export default __webpack_public_path__ + "static/media/alerts.3852f35a.svg";